import BasicState from "@libs/basic-view"   
import FestStatisticForm from "./statistics/FestStatisticForm"  
import { useFestStatistic } from "../data/store"

class FestStatisticView extends BasicState { 
    contextMethods:any = useFestStatistic.getState().contextMethods
    addRender = () => {  
        return <> 
            <FestStatisticForm /> 
        </>
    }
}

export default FestStatisticView 